"use strict";
// This file was generated by bin/generate-get-icon-name.js.
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIconName = void 0;
const REUSED_ICONS = {
    BICYCLES: 'BICYCLE',
    CANOES_MULTIPLE: 'CANOE',
    JET_SKIS: 'JET_SKI',
    KAYAKS: 'KAYAK',
    PADDLEBOARDS_MULTIPLE: 'PADDLEBOARD',
    SCOOTERS: 'SCOOTER',
    SEABOBS: 'SEABOB',
    UNDERWATER_SCOOTERS: 'UNDERWATER_SCOOTER',
    WAVE_RUNNERS: 'WAVE_RUNNER',
    TV_ALL_CABINS: 'TV',
    TV_MASTER_CABIN: 'TV',
    TV_SALOON: 'TV',
};
const getIconName = (name) => REUSED_ICONS[name] || name;
exports.getIconName = getIconName;
//# sourceMappingURL=get-icon-name.js.map